import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
    selector: 'cv-leaderboard-rank-cell-renderer',
    templateUrl: './leaderboard-rank-cell-renderer.component.html',
    styleUrls: ['./leaderboard-rank-cell-renderer.component.scss']
})
export class LeaderboardRankCellRendererComponent implements AgRendererComponent {

    params!: ICellRendererParams;
    rank: string = '';
    rankIcon: string = '';
    shouldShowIcon: boolean = false;
    ordinalSuffixes = ['st', 'nd', 'rd', 'th'];

    constructor(
        private cvLocalizationService: CVLocalizationService,
    ) { }

    refresh(params: ICellRendererParams): boolean {
        this.params = params;
        if (this.params.data.MetricData.MetricDisplayValue !== null && this.params.data.MetricData.MetricDisplayValue !== 'N/A' && !params['noRankings']) {
            this.rankIcon = this.getIconUrl(this.params.value);
            this.rank = this.rankIcon == null ? this.getRankValue(this.params.value) : null;
        }
        else {
            this.rankIcon = null;
            this.rank = this.cvLocalizationService.getCachedText('Leaderboard_Module', 'Rank_NA');
        }

        return true;
    }

    agInit(params: ICellRendererParams): void {
        this.params = params;
        if (this.params.data.MetricData.MetricDisplayValue !== null && this.params.data.MetricData.MetricDisplayValue !== 'N/A' && !params['noRankings']) {
            this.ordinalSuffixes = [
                this.getLocalization('St_Symbol', 'st'),
                this.getLocalization('Nd_Symbol', 'nd'),
                this.getLocalization('Rd_Symbol', 'rd'),
                this.getLocalization('Th_Symbol', 'th')
            ];
            this.rankIcon = this.getIconUrl(this.params.value);
            this.rank = this.rankIcon == null ? this.getRankValue(this.params.value) : null;
        }
        else {
            this.rankIcon = null;
            this.rank = this.cvLocalizationService.getCachedText('Leaderboard_Module', 'Rank_NA');
        }
    }

    private getLocalization(key: string, defaultValue: string) {
        return this.cvLocalizationService.getCachedText('Leaderboard_Module', key, defaultValue);
    }

    private getRankValue(value) {
        this.shouldShowIcon = false;
        for (const suffix of this.ordinalSuffixes) {
            if (value.includes(suffix)) {
                return value.replace(suffix, '');
            }
        }

        return value;
    }

    private getIconUrl(rank) {
        let url;
        this.shouldShowIcon = true;
        switch (rank) {
            case `1${this.ordinalSuffixes[0]}`:
                return url = "../App_Themes/CXone/icons/cxone-first-rank.svg#cxone-first-rank";
            case `2${this.ordinalSuffixes[1]}`:
                return url = "../App_Themes/CXone/icons/second-rank.svg#second-rank";
            case `3${this.ordinalSuffixes[2]}`:
                return url = "../App_Themes/CXone/icons/third-rank.svg#third-rank";
            default:
                return null;
        }
    }
}
